/**
 * Abstract base class for fire-once skills with no sustained state.
 * Provides no-op defaults for deactivate, update, and destroy.
 * Subclasses implement canActivate and activate — everything else is optional.
 */
import type { SkillEffect } from './SkillEffect';

/** Base class for fire-and-forget skills with no active state or cooldown management. */
export abstract class InstantSkillEffect implements SkillEffect {
  readonly type = 'active' as const;
  readonly activationMode = 'instant' as const;
  abstract readonly skillId: string;

  get cooldown(): number { return 0; }
  isActive(): boolean { return false; }
  deactivate(): void {}
  update(_delta: number): void {}
  destroy(): void {}

  abstract canActivate(): boolean;
  abstract activate(): boolean;
}
